import { useEffect } from 'react';
import { FormComponentProps } from '@ant-design/compatible/lib/form';

import useEventDetail from '../../../../hooks/queries/event/useEventDetail';
import { convertGetEventDetailResponseData } from '../utils';
import { EventDetailResponse } from '../../../../types/query/event/detail';

interface UseInitialValueProps extends FormComponentProps {
  id?: number;
  setEventSectionTabKey: React.Dispatch<React.SetStateAction<number | null>>;
}
const useEventDetailInitialValue = ({ form, id, setEventSectionTabKey }: UseInitialValueProps) => {
  const result = useEventDetail<EventDetailResponse>({
    payload: id!,
    options: {
      enabled: !!id,
      select: convertGetEventDetailResponseData,
    },
  });

  useEffect(() => {
    // 데이터를 받아왔을 때 getFieldsValue 로 필드에서 초기값을 알 수 있게 하기 위함
    if (!result.data) return;

    form.setFieldsValue({
      mainTitle: result.data.mainTitle,
      status: result.data.status,
      contents: result.data.contents,
      memo: result.data.memo,
    });
  }, [result.data]);

  useEffect(() => {
    // 섹션텝 초기화
    if (!result.data?.eventSectionList.length) return;

    setEventSectionTabKey(result.data?.eventSectionList[0].id);
  }, [result.data?.eventSectionList]);

  return {
    ...result,
  };
};

export default useEventDetailInitialValue;
